module.exports = __webpack_public_path__ + "img/rob_gaoya.58540a35.png";